import Magistrado from '@/model/Magistrado';
import { uiStore } from '@/store';
import { RestApi } from '@pjn/ajax/Api';
import { AxiosInstance } from '@pjn/ajax/HttpClient';
import { toEntity } from '@pjn/ajax/helpers';
import Configuracion from '@/model/Configuracion';
import { mapConfigsFrom, mapConfigsTo } from './utils/Mappers';

/** URL base de la API de magistrados */
const CONFIGURACION_URL = process.env.VUE_APP_DENUNCIAS_URL + '/config';

  
export class ConfiguracionRestApi extends RestApi<Magistrado> {
  constructor(http: AxiosInstance) {
    super(http, CONFIGURACION_URL);
  }
  save(configuracion: Configuracion) {

    return this.http
      .put(`${CONFIGURACION_URL}`, mapConfigsFrom(configuracion))
      .then(toEntity<Configuracion>(mapConfigsTo))
      .catch(error => {
        uiStore.notification.error(error);
        throw error;
      });
  }

    get() {
    return this.http
      .get(`${CONFIGURACION_URL}`)
      .then(toEntity<Configuracion>(mapConfigsTo))
      
      .catch(error => {
        return Promise.reject(error.message || error);
      });
    }


}
